/* eslint-disable import/no-unresolved */
import {
    Button, Modal, ModalBody, ModalFooter,
} from 'appkit-react';
import { useState } from 'react';

import FileExplorerContainer from 'views/DataRecon/FileExplorer/containers/FileExplorerContainer';

import '../styles/addFilesModal.scss';

const AddFilesToCrossReportFlag = true;

const AddFilesModal = ({
    visible, onFileExplorerClosed, tenantId, setDataSourceFileId,
    assignDataSourceLoading, setDataSourceBatchId, setDataSourceFileName,
}) => {
    const [filesToAdd, setfilesToAdd] = useState([]);
    const [fileName, setFileName] = useState();

    const onSave = async () => {
        setDataSourceBatchId(null);
        setDataSourceFileId(filesToAdd[0]);
        setDataSourceFileName(fileName);
    };

    return (
        <Modal
            visible={visible}
            onCancel={onFileExplorerClosed}
            style={{ marginLeft: '-17rem', width: '69rem' }}
            backdropClosable={false}
        >
            <ModalBody style={{ padding: 0, marginTop: '1rem' }}>
                <div className="cross-report-file-explorer">
                    <FileExplorerContainer
                        tenantId={tenantId}
                        AddFilesToCrossReportFlag={AddFilesToCrossReportFlag}
                        setfilesToAdd={setfilesToAdd}
                        setFileName={setFileName}
                    />
                </div>
            </ModalBody>
            <ModalFooter style={{ justifyContent: 'flex-end' }}>
                <Button kind="secondary" onClick={onFileExplorerClosed} size="lg"> CANCEL </Button>
                <Button
                    kind="primary"
                    size="lg"
                    onClick={onSave}
                    disabled={filesToAdd.length === 0 || filesToAdd.length > 1}
                    isLoading={assignDataSourceLoading}
                >
                    ADD FILE
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default AddFilesModal;
